<template>
    <section class="footer-wrapper">
			<div class="container global-container">
				<el-row>
					<el-col :xs="24" :md="12">
						<div class="footer-left">
							<el-button type="text" class="text-info" v-html="copy_info"></el-button>
						</div>
					</el-col>
					<el-col :xs="24" :md="12">
						<div class="footer-right">
							<span class="text-info">
								<a class="florina-href" href="http://www.florina.cn" target="_blank">www.florina.cn</a>
								400-999-9394 info@florina.cn
							</span>
						</div>
					</el-col>
				</el-row>
			</div>
		</section>
</template>
<script>
export default {
	name:'Ffooter',
	data(){
		return {
			copy_info:'Copyright &copy; 2019 Florina 费罗娜 保留所有权利'
		}
	}
}
</script>
<style lang="scss" scoped>
@import '@/style/custom-variables.scss';
.footer-wrapper{
	width: 100%;
	height: 80px;
	line-height: 80px;
	font-size: 14px;
	display: flex;
	align-items: center;
	border-top: 1px solid #e2e1e1;
	background-color: $common_bg;
	overflow: hidden;
	.container{
		.footer-left{
			text-align: left;
			height: 45px;
			line-height: 45px;
			overflow: hidden;
		}
		.footer-right{
			text-align: right;
			height: 45px;
			line-height: 45px;
			overflow: hidden;
		}
		.text-info{
			color: #989898;
		}
		.florina-href{
			color: #989898;
			text-decoration: none;
			cursor: pointer;
			margin: 0 5px;
			&:hover{
				color: #1989fa;
			}
		}
	}
}
@media screen and (max-width:1200px) {
	.footer-wrapper{
		padding: 5px 0;
		line-height: 24px;
		.container{
			.footer-left{
				text-align: center;
			}
			.footer-right{
				text-align: center;
			}
		}
	}
}
</style>


